import React, { useMemo, useState } from "react";
import { Helmet } from "react-helmet";
import { HydraTable, Heading, TextFilter, DateRangeFilter } from "@peracto/peracto-ui";
import dayjs from "dayjs";

import { GET_LIST, useClient } from "@peracto/client";

export const VinReportsList = () => {
    // Default visible columns - key = column accessor
    const [selectedColumns, onSelectColumn] = useState();

    const { client } = useClient();

    const tableColumns = [
        {
            Header: "User Email",
            accessor: "user.email",
            sortType: "basic",
            disableSorting: true,
            Filter: (props) => <TextFilter label="User Email" {...props} />,
            selectable: false,
        },
        {
            Header: "VIN",
            accessor: "vehicleVin",
            sortType: "basic",
            disableSorting: true,
            Filter: (props) => <TextFilter label="Vehicle VIN" {...props} />,
            selectable: false,
        },
        {
            Header: "VRM",
            accessor: "vehicleReg",
            sortType: "basic",
            disableSorting: true,
            Filter: (props) => <TextFilter label="VRM" {...props} />,
            selectable: false,
        },
        {
            Header: "Account Number",
            accessor: "accountNumber",
            sortType: "basic",
            disableSorting: true,
            Filter: (props) => <TextFilter label="Account Number" {...props} />,
            selectable: false,
        },
        {
            Header: "Branch",
            accessor: "branchNumber",
            sortType: "basic",
            disableSorting: true,
            Filter: (props) => <TextFilter label="Branch Number" {...props} />,
            selectable: false,
        },
        {
            Header: "Created At",
            accessor: "createdAt",
            sortType: "basic",
            disableSorting: true,
            Filter: (props) => <DateRangeFilter label="Created At" {...props} />,
            Cell: ({ cell: { value } }) =>
                new Date(value) > 0 ? dayjs(value).format("DD MMM YYYY HH:mm:ss") : "-",
            selectable: false,
        },
    ];

    // The 'selectable' property is used to define if the
    // column is available in the 'manage columns' dropdown
    const columns = useMemo(() => tableColumns, [tableColumns]);

    const onFetchData = (options) => {
        return client(GET_LIST, "vin-reports", {
            ...options,
            id: "vin-reports",
        });
    };

    return (
        <>
            <Helmet>
                <title>VIN Reports | Peracto</title>
            </Helmet>
            <Heading name="VIN Reports" />

            <div className="row">
                <div className="col">
                    <div className="card card--transparent">
                        <div className="card-body">
                            <HydraTable
                                columns={columns}
                                selectedColumns={selectedColumns}
                                onFetchData={onFetchData}
                                onSelectColumn={onSelectColumn}
                                defaultFilters={{
                                    "user.email": "",
                                    vehicleVin: "",
                                    accountNumber: "",
                                    branchNumber: "",
                                    vehicleReg: "",
                                    createdAt: "",
                                }}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default VinReportsList;
